/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @type NotificationChannelEmail
 * 
 * @export
 */
export type NotificationChannelEmail = string;

export function NotificationChannelEmailFromJSON(json: any): NotificationChannelEmail {
    return NotificationChannelEmailFromJSONTyped(json, false);
}

export function NotificationChannelEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationChannelEmail {
    if (json == null) {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    return {} as any;
}

export function NotificationChannelEmailToJSON(json: any): any {
    return NotificationChannelEmailToJSONTyped(json, false);
}

export function NotificationChannelEmailToJSONTyped(value?: NotificationChannelEmail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    return {};
}

